import { Form, Formik, FormikHelpers } from "formik";
import { AssignTestsFormValue } from "src/models/AssignTest.model";
import { useAssignTestMutation } from "src/services/TestSeriesServices";
import { showToast } from "src/utils/showToaster";
import { object } from "yup";
import AssignTestForm from "./AssignTestForm";

const AssignTestWrapper = () => {
  const [assignTest] = useAssignTestMutation();

  // Form Initial Values
  const initialValues: AssignTestsFormValue = {
    testId: "",
    batchId: "",
    students: [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    testId: object().required("Please select test"),
    // batchId: object().test(
    //   "batchId-test",
    //   "Please select batch if students are not selected",
    //   function (value: any) {
    //     const { studentsId } = this.parent;
    //     if ((!studentsId || studentsId.length === 0) && !value) {
    //       return false;
    //     }
    //     return true;
    //   }
    // ),
    // studentsId: array().test(
    //   "studentsId-test",
    //   "Please select students if batch is not selected",
    //   function (value: any) {
    //     const { batchId } = this.parent;
    //     if (!batchId && (!value || value.length === 0)) {
    //       return false;
    //     }
    //     return true;
    //   }
    // ),
  });

  // Handle Submit
  const handleSubmit = (
    values: AssignTestsFormValue,
    { setSubmitting, resetForm }: FormikHelpers<AssignTestsFormValue>
  ) => {
    const formatedValues = {
      testId: values?.testId?.value,
      batchId: (values.batchId?.value as any) || null,
      studentsId: values.students?.map((ele: any) => ele?.value),
    };

    assignTest(formatedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form className="h-full overflow-hidden contents">
            <AssignTestForm
              formikProps={formikProps}
              // onClose={onClose}
              // formType="Add"
              // setSaveNextChecked={setSaveNextChecked}
              // saveNextChecked={saveNextChecked}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AssignTestWrapper;
